module.exports = __webpack_public_path__ + "img/56.4dab8393.jpg";